import React, { useEffect, useState } from 'react'
import useHttp from '../../../hook/use-http';
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates_bus';
import moment from 'moment';

function BDT_Dashboard_Cards(props) {
    const { isLoading, error, sendReq: fetchData } = useHttp();

    const { title, apiEnd, temp, tempTtl } = props.data
    const { filterdata, packType } = props
    const [value, setValue] = useState(0)

    useEffect(() => {
        fetchData(
            {
                url: API_URL_MAIN + `battery_digital_twin/${apiEnd}`,
                body: { filterdata, packType },
            },
            (data) => {
                if (data?.value) {
                    setValue(data?.value)
                }
                else if (data?.divisionResult) {
                    setValue(data?.divisionResult)
                }
                else {
                    setValue(0)
                }
            }
        );
    }, [props]);


    return (
        <div className="shadow rounded-3 bg-white" >
            {/* <p className="pt-4 text-center">{title}</p> */}
            <p className={(temp && temp === "1") ? "pt-2 text-center mb-2" : "pt-4 text-center"}>{title}</p>
            {
                apiEnd !== "" ?
                    title == "AVG Cycles Per Month" ?
                        <p className="text-center font-weight-bold fs-6 pb-3">{value?.toFixed(2)}</p>
                        :
                        <p className="text-center font-weight-bold pb-3 fs-6">{value ? moment().add(Math.floor(value), 'months').format('MMMM YYYY') : "--"}</p>
                    :
                    temp === "1" ?
                        <>
                            <p className="text-center font-weight-bold fs-6 mb-2">Cell Id : NA</p>
                            <p className="text-center font-weight-bold fs-6 pb-3">{tempTtl}</p>
                        </>
                        :
                        <p className="text-center font-weight-bold fs-6 pb-3">Cell Id : NA</p>
            }
        </div >
    )
}

export default BDT_Dashboard_Cards
